// Shared color + label system for the two minutes indicators, used identically
// in Jugadores, fichas individuales and Dashboard del equipo.
//
//  A = "% minutos sobre partidos del equipo"
//      minutos / Σ duración de TODOS los partidos disputados del equipo
//  B = "% minutos en partidos convocados"
//      minutos / Σ duración de los partidos en los que fue convocado

export const MIN_A = {
  key: "total",
  short: "% min. equipo",
  long: "% minutos sobre partidos del equipo",
  color: "#2563EB",            // blue-600
  text: "text-blue-600",
  bg: "bg-blue-50",
  border: "border-blue-200",
  chip: "bg-blue-100 text-blue-700 border-blue-300",
};

export const MIN_B = {
  key: "called",
  short: "% min. convocado",
  long: "% minutos en partidos convocados",
  color: "#9333EA",            // purple-600
  text: "text-purple-600",
  bg: "bg-purple-50",
  border: "border-purple-200",
  chip: "bg-purple-100 text-purple-700 border-purple-300",
};

// Homogeneous palette for the rest of the shared indicators (same colour for the
// same metric across Jugadores and Dashboard del equipo).
export const STAT_COLORS = {
  attendance: { text: "text-emerald-600", color: "#059669", chip: "bg-emerald-100 text-emerald-700 border-emerald-300" },
  punctuality: { text: "text-amber-600", color: "#D97706", chip: "bg-amber-100 text-amber-700 border-amber-300" },
  minutes_total: MIN_A,
  minutes_called: MIN_B,
  called: { text: "text-slate-700", color: "#334155", chip: "bg-slate-100 text-slate-700 border-slate-300" },
  goals: { text: "text-emerald-700", color: "#047857" },
};

export const SCOPES = [
  { v: "competition", label: "Competición", phase: "COMPETITION" },
  { v: "no_pre", label: "Totales", phase: "" },
  { v: "preseason", label: "Pretemporada", phase: "PRESEASON" },
  { v: "all", label: "Todo", phase: "" },
];
export const DEFAULT_SCOPE = "competition";

export const scopeToPhase = (scope) =>
  scope === "competition" ? "COMPETITION"
    : scope === "preseason" ? "PRESEASON"
      : scope === "no_pre" ? "NO_PRE"
        : ""; // all

export const inScope = (phase, scope) =>
  scope === "all" ? true
    : scope === "preseason" ? phase === "PRESEASON"
      : scope === "competition" ? phase === "COMPETITION"
        : phase !== "PRESEASON"; // no_pre (Totales = sin pretemporada)

const r1 = (n) => Math.round(n * 10) / 10;

// Build the exact calculation for both indicators from matches-detail records.
// Each record: { season_phase, pending, called, minutes, duration, ... }
// Returns null pct when there is no valid denominator ("Sin datos").
export function computeMinuteIndicators(matches, scope) {
  const scoped = (matches || []).filter((m) => inScope(m.season_phase, scope) && !m.pending);
  // A — all played team matches (called or not)
  const aGames = scoped;
  const aDen = aGames.reduce((s, m) => s + (m.duration || 0), 0);
  const aNum = aGames.reduce((s, m) => s + (m.minutes || 0), 0);
  // B — only matches the player was called to
  const bGames = scoped.filter((m) => m.called);
  const bDen = bGames.reduce((s, m) => s + (m.duration || 0), 0);
  const bNum = bGames.reduce((s, m) => s + (m.minutes || 0), 0);
  return {
    total: { num: aNum, den: aDen, pct: aDen ? r1((aNum / aDen) * 100) : null, games: aGames },
    called: { num: bNum, den: bDen, pct: bDen ? r1((bNum / bDen) * 100) : null, games: bGames },
  };
}

export const fmtPct = (v) => (v == null ? "Sin datos" : `${String(v).replace(".", ",")}%`);
